import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const InputNumberMeta: ComponentMeta = {
  componentName: "InputNumber",
  package: "@mijadesign/web",
  title: "数字输入框",
  description: "用于输入数字的输入框组件",
  category: ComponentCategory.FORM,
  icon: "NumberOutlined",
  canHaveChildren: false,
  props: [
    {
      name: "value",
      label: "值",
      type: PropType.NUMBER,
      group: "数据",
    },
    {
      name: "defaultValue",
      label: "默认值",
      type: PropType.NUMBER,
      group: "默认",
    },
    {
      name: "placeholder",
      label: "占位提示",
      type: PropType.STRING,
      defaultValue: "请输入数字",
      group: "基础",
    },
    {
      name: "min",
      label: "最小值",
      type: PropType.NUMBER,
      group: "限制",
    },
    {
      name: "max",
      label: "最大值",
      type: PropType.NUMBER,
      group: "限制",
    },
    {
      name: "step",
      label: "步长",
      type: PropType.NUMBER,
      defaultValue: 1,
      group: "控制",
    },
    {
      name: "precision",
      label: "精度",
      type: PropType.NUMBER,
      description: "小数位数",
      group: "控制",
    },
    {
      name: "disabled",
      label: "禁用",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
    {
      name: "size",
      label: "尺寸",
      type: PropType.ENUM,
      defaultValue: "middle",
      options: [
        { label: "大", value: "large" },
        { label: "中", value: "middle" },
        { label: "小", value: "small" },
      ],
      group: "样式",
    },
    {
      name: "controls",
      label: "显示控制按钮",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "功能",
    },
    {
      name: "addonBefore",
      label: "前置标签",
      type: PropType.STRING,
      group: "装饰",
    },
    {
      name: "addonAfter",
      label: "后置标签",
      type: PropType.STRING,
      group: "装饰",
    },
  ],
  defaultProps: {
    placeholder: "请输入数字",
    step: 1,
    controls: true,
  },
  defaultStyle: {
    width: 100,
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "InputNumber",
  },
  snippet: {
    componentName: "InputNumber",
    package: "@mijadesign/web",
    props: { placeholder: "请输入数字" },
  },
};
